import { useState } from "react";
import { signInWithPopup, GoogleAuthProvider, sendPasswordResetEmail, confirmPasswordReset, signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../utils/firebase.js';
import { postSignInCheck } from "../data/users.js";
import Icon from '@mdi/react';
import { mdiCheckCircle, mdiEmail, mdiAt, mdiLock, mdiBadgeAccountHorizontalOutline, mdiCheckBold } from '@mdi/js';
import GoogleIcon from '../media/google-icon.svg';
import { toggleModal } from "../utils/uiUtils.js";
import meeplePile from "../media/meeplePile.jpeg";
import Logo from "../media/logo.js";


function NotSignedIn({ requestedUrl }) {
    const [loginEmail, setLoginEmail] = useState();
    const [loginPassword, setLoginPassword] = useState();

    const googleHandler = async () => {
        const provider = new GoogleAuthProvider();
        provider.setCustomParameters({ prompt: 'select_account' });
        provider.setCustomParameters({ prompt: 'select_account' });
        await signInWithPopup(auth, provider)
            .then(async (result) => {
                await postSignInCheck();
                if (requestedUrl && requestedUrl.trim() !== "") {
                    window.location.href = requestedUrl;
                }
            }).catch((exception) => {
                console.log(exception);
            });
    };

    const SignInWithEmailAndPasswordHandler = async () => {
        signInWithEmailAndPassword(auth, loginEmail, loginPassword).then(async (userCredential) => {
            await postSignInCheck();
            if (requestedUrl && requestedUrl.trim() !== "") {
                window.location.href = requestedUrl;
            }
        }).catch((e) => {
            console.log(e);
            document.getElementById("loginFailedMessage").classList.remove("is-hidden");
        });
    };

    const signUpWithEmailHandler = async () => {
        var email = document.getElementById("signupEmail").value;
        var displayName = document.getElementById("signupDisplay").value;
        var password = document.getElementById("signupPassword").value;
        var passwordConfirm = document.getElementById("signupPasswordConfirm").value;
        var formValid = true;

        document.getElementById("signupEmail").classList.remove("is-danger");
        document.getElementById("signupDisplay").classList.remove("is-danger");
        document.getElementById("signupPassword").classList.remove("is-danger");
        document.getElementById("signupPasswordConfirm").classList.remove("is-danger");
        document.getElementById("termsCheckboxLabel").classList.remove("red-border-3");

        if (!document.getElementById("termsCheckbox").checked) {
            formValid = false;
            document.getElementById("termsCheckboxLabel").classList.add("red-border-3");
        }

        if (!email) {
            formValid = false;
            document.getElementById("signupEmail").classList.add("is-danger");
        }

        if (!displayName) {
            formValid = false;
            document.getElementById("signupDisplay").classList.add("is-danger");
        }

        if (!checkPasswordStrength(password)) {
            formValid = false;
            document.getElementById("signupPassword").classList.add("is-danger");
        }

        if (password !== passwordConfirm) {
            formValid = false;
            document.getElementById("signupPasswordConfirm").classList.add("is-danger");
        }

        if (!formValid) {
            return;
        }

        createUserWithEmailAndPassword(auth, email, password).then((userCredential) => {
            // Signed in 
            const user = userCredential.user;
            postSignInCheck(displayName);
            // ...
        }).catch(() => {
            document.getElementById("signupFailedMessage").classList.remove("is-hidden");
        });
    }

    const checkPasswordStrength = (password) => {
        if (typeof password !== 'string') {
            return false;
        }

        const hasDigit = /[0-9]/.test(password);
        const hasUpperCase = /[A-Z]/.test(password);
        const hasLowerCase = /[a-z]/.test(password);
        const passwordLength = password.length;
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

        return passwordLength >= 8 && hasDigit && hasUpperCase && hasLowerCase && hasSpecialChar;
    }

    const checkPassword = (password, passwordStrengthIcon, passwordConfirm, passwordConfirmIcon) => {
        var passwordMeetsRequirements = checkPasswordStrength(password);

        if (passwordMeetsRequirements) {
            passwordStrengthIcon.classList.remove("is-hidden");
            document.getElementById("signupPassword").classList.remove("is-danger");
            if (password === passwordConfirm) {
                passwordConfirmIcon.classList.remove("is-hidden");
                document.getElementById("signupPassword").classList.remove("is-danger");
            } else {
                passwordConfirmIcon.classList.add("is-hidden");
            }
        } else {
            passwordStrengthIcon.classList.add("is-hidden");
            passwordConfirmIcon.classList.add("is-hidden");
        }
    }

    const togglePasswordVisibility = (passwordField, passwordLinkField) => {
        const passwordInput = document.getElementById(passwordField);
        const passwordLink = document.getElementById(passwordLinkField);

        if (passwordInput.type === "password") {
            passwordInput.type = "text";
            passwordLink.innerText = "Hide Password";
        } else {
            passwordInput.type = "password";
            passwordLink.innerText = "Show Password";
        }
    }
    const resetPasswordHandler = () => {
        document.getElementById("missingEmailMessage").classList.add("is-hidden");
        if (!loginEmail || loginEmail.trim() === "") {
            document.getElementById("missingEmailMessage").classList.remove("is-hidden");
            return;
        }

        sendPasswordResetEmail(auth, loginEmail)
            .then(() => {
                toggleModal('modal-reset-password');
            }).catch(() => {
                toggleModal('modal-reset-password');
            });
    }

    return (
        <>
            <div className="image-card box-is-rounded p-0">
                <div className="columns is-mobile p-0">
                    <div className="column is-offset-3 is-6-desktop is-6-mobile has-text-centered p-6">
                        <div className="mb-5">
                            <Logo width="11" textColor={"#34495e"} />
                        </div>

                        <h1 className="title is-4">Admin Tools</h1>

                        {/* Feature Bullets */}
                       
                        {/* Email Field */}
                        <div className="field">
                            <div className="control has-icons-left">
                                <input className="input" type="email" placeholder="Email" onChange={(event) => { setLoginEmail(event.currentTarget.value) }} />
                                <span className="icon is-small is-left">
                                    <Icon path={mdiEmail} size={1} />
                                </span>
                            </div>
                        </div>
                        <div className="is-hidden has-text-weight-bold has-text-danger-dark" id="missingEmailMessage">
                            Enter your email address in order to request a new password.
                        </div>

                        {/* Password Field */}
                        <div className="field">
                            <div className="control has-icons-left">
                                <input className="input" id="passwordInput" type="password" placeholder="Password" onChange={(event) => { setLoginPassword(event.currentTarget.value) }} />
                                <span className="icon is-small is-left">
                                    <Icon path={mdiLock} size={1} />
                                </span>
                            </div>
                            <div id="togglePasswordLink" className="is-clickable has-text-left is-size-7 is-underlined is-link" onClick={() => { togglePasswordVisibility('passwordInput', 'togglePasswordLink'); }}>
                                Show password
                            </div>
                        </div>

                        {/* Login Button */}
                        <div className="field">
                            <button className="button is-primary is-fullwidth has-text-weight-bold" onClick={() => { SignInWithEmailAndPasswordHandler() }}>
                                Login with Password
                            </button>
                        </div>

                        <div className="is-hidden has-text-weight-bold has-text-danger-dark" id="loginFailedMessage">
                            Something went wrong. Check your email and password and try again, or click to <span className="is-link"><a href="#" onClick={() => { resetPasswordHandler(); }}>Reset Your Password</a></span> (a link will be sent to the email entered above).
                        </div>                      

                        {/* Divider */}
                        <div className="is-divider" data-content="OR"></div>

                        {/* Google Login Button */}
                        <div className="field">
                            <button className="button is-fullwidth" onClick={googleHandler}>
                                <span className="icon">
                                    <img src={GoogleIcon} />
                                </span>
                                <span>Sign In with Google</span>
                            </button>
                            <div className="is-size-7 is-text-left has-text-weight-semibold">
                                By continuing with Google, you confirm you are at least 13 years old
                                and agree to our <a href="/termsAndConditions" className="is-link">Terms and Conditions</a>.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr />

            <div id="modal-reset-password" className="modal">
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head">
                        <p className="modal-card-title">Password Reset Sent</p>
                        <button className="delete" aria-label="close" onClick={() => { toggleModal('modal-reset-password') }}></button>
                    </header>
                    <section className="modal-card-body">
                        <p>If an account for this email was found in our system a link to reset your password will be sent to it.
                            Follow the instructions to reset your password, then come back to the site and log in again.</p>
                    </section>
                    <footer className="modal-card-foot">
                        <button className="button" aria-label="close" onClick={() => { toggleModal('modal-reset-password') }}>Close</button>
                    </footer>
                </div>
            </div>
        </>
    );
}

export default NotSignedIn;